import { normalizeTrailingSlash } from '@/shared/lib/url-utils';

// Environment variables
export const API_BASE_URL = normalizeTrailingSlash(import.meta.env.VITE_API_BASE_URL || '');

// Azure AD configuration
export const AZURE_CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID || '';
export const AZURE_TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID || '';

// WFP CIAM configuration
export const CIAM_CLIENT_ID = import.meta.env.VITE_CIAM_CLIENT_ID || '';
export const CIAM_CLIENT_SECRET = import.meta.env.VITE_CIAM_CLIENT_SECRET || '';

export const LOGCLUSTER_URL = 'https://logcluster.org/';
export const WFP_URL = 'https://wfp.org/';
